import { useSelector } from "@xstate/store-react";
import { agentActiveThreadStore } from "./agent-active-thread-store";

export const useActiveThreadId = () => useSelector(agentActiveThreadStore, (s) => s.context.activeThreadId);

export function setActiveThreadId(threadId: string | null): void {
  agentActiveThreadStore.send({ type: "active.set", threadId });
}

export function clearActiveThread(): void {
  agentActiveThreadStore.send({ type: "active.clear" });
}
